/** Espelha ExcluirEstoqueVendaRequest do OrquestradorVendas (POST ProcessoVenda/idVenda/{id}/estoque/excluir). */
export class ExcluirEstoqueVendaRequest {
    /** Opcional (até 500 caracteres); vai para a ocorrência de exclusão do pedido. */
    justificativa: string | null = null;
}
